import {
  createFormField,
  FormFieldBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';
import { AsyncServiceSelect } from './function';

export const AsyncServiceSelectFormField = FormFieldBlueprint.make({
  name: 'async-service-select',
  params: {
    field: async () =>
      createFormField({
        name: 'AsyncServiceSelect',
        component: AsyncServiceSelect,
      }),
  },
});
